import { IClassroomListQueryParameters } from "./classroomListQuery";
import { createApiQueryHook, IApiQueryFunction, mapOrder, mapPagination } from "../../utils/api";
import { mapRelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IClassroomList } from "../types/IClassroomList";

export type IClassroomStatisticsListQueryParameters = IClassroomListQueryParameters;

export type IClassroomStatisticsListQueryResult = IClassroomList;

const mapFilters = (filters: IClassroomStatisticsListQueryParameters["filters"]) => {
    const {
        title,
        description,
        locationTitle,
        externalReferences,
        frameworks,
        factory,
        learners,
        trainers,
        restricted,
        startDateBefore,
        startDateStrictlyBefore,
        startDateAfter,
        startDateStrictlyAfter,
        endDateBefore,
        endDateStrictlyBefore,
        endDateAfter,
        endDateStrictlyAfter,
        groups,
        forceActive,
    } = filters ?? {};

    return {
        title,
        description,
        externalReferences,
        restricted,
        forceActive,
        groups,
        "location.title": locationTitle,
        "frameworks.uuid": mapRelationalFilter(frameworks),
        "factory.uuid": mapRelationalFilter(factory),
        "learners.uuid": mapRelationalFilter(learners),
        "trainers.uuid": mapRelationalFilter(trainers),
        "startDate[before]": startDateBefore,
        "startDate[strictly_before]": startDateStrictlyBefore,
        "startDate[after]": startDateAfter,
        "startDate[strictly_after]": startDateStrictlyAfter,
        "endDate[before]": endDateBefore,
        "endDate[strictly_before]": endDateStrictlyBefore,
        "endDate[after]": endDateAfter,
        "endDate[strictly_after]": endDateStrictlyAfter,
    };
};

export const classroomStatisticsListQuery: IApiQueryFunction<IClassroomStatisticsListQueryParameters> = ({
    filters,
    order,
    pagination,
}) => {
    return {
        method: "GET",
        url: `/classrooms/statistics${serialize(
            { ...mapPagination(pagination), ...mapOrder(order), ...mapFilters(filters) },
            true,
        )}`,
    };
};

export const useClassroomStatisticsListQuery = createApiQueryHook<
    IClassroomStatisticsListQueryParameters,
    IClassroomStatisticsListQueryResult,
    any
>(classroomStatisticsListQuery);
